import React from 'react'
import axios from 'axios'
import { Typography, IconButton } from '@material-ui/core'
import { Delete as DeleteIcon, Close as CloseIcon } from '@material-ui/icons'
import AreaPhotoUploader from './AreaPhotoUploader'

const AreaPhotoGallery = ({ areaId, url }) => {
  const [photos, setPhotos] = React.useState([])
  const [lightboxUrl, setLightboxUrl] = React.useState(null)

  React.useEffect(() => {
    if (areaId) {
      axios.get(`${url}/api/bid-estimation/areas/${areaId}/photos`).then(res => {
        setPhotos(res.data)
      }).catch(err => console.error('Failed to fetch photos:', err))
    }
  }, [areaId])

  const handleDelete = (uploadId) => {
    axios.delete(`${url}/api/bid-estimation/areas/${areaId}/photos/${uploadId}`).then(() => {
      setPhotos(prev => prev.filter(p => p._id !== uploadId))
    }).catch(err => console.error('Failed to delete photo:', err))
  }

  const handlePhotoAdded = (upload) => {
    setPhotos(prev => [upload, ...prev])
  }

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <Typography variant="subtitle2" style={{ fontWeight: 600, fontSize: 13 }}>Photos</Typography>
        <AreaPhotoUploader areaId={areaId} url={url} onPhotoAdded={handlePhotoAdded} />
      </div>
      {photos.length === 0 ? (
        <Typography variant="body2" color="textSecondary" style={{ fontSize: 12 }}>No photos yet.</Typography>
      ) : (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {photos.map(p => (
            <div key={p._id} style={{ position: 'relative' }}>
              <img
                src={p.s3Url}
                alt={p.originalFilename}
                style={{ width: 120, height: 90, objectFit: 'cover', borderRadius: 4, cursor: 'pointer' }}
                onClick={() => setLightboxUrl(p.s3Url)}
              />
              <IconButton
                size="small"
                onClick={() => handleDelete(p._id)}
                style={{ position: 'absolute', top: 2, right: 2, backgroundColor: 'rgba(0,0,0,0.5)', color: '#fff', padding: 2 }}
              >
                <DeleteIcon style={{ fontSize: 14 }} />
              </IconButton>
            </div>
          ))}
        </div>
      )}

      {/* Lightbox overlay */}
      {lightboxUrl && (
        <div
          onClick={() => setLightboxUrl(null)}
          style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 9999,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}
        >
          <IconButton
            onClick={() => setLightboxUrl(null)}
            style={{ position: 'absolute', top: 16, right: 16, color: '#fff' }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={lightboxUrl}
            alt="Full size"
            style={{ maxWidth: '90vw', maxHeight: '90vh', borderRadius: 8 }}
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  )
}

export default AreaPhotoGallery
